import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import SafeIcon from '../../common/SafeIcon';
import { FiActivity, FiMail, FiPhone, FiUser } from 'react-icons/fi';


const RecentActivity = () => {
  const activities = [
    {
      id: 1,
      type: 'email',
      title: 'Email campaign sent',
      description: 'Welcome Series - 150 contacts',
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
      icon: FiMail,
      color: 'blue'
    },
    {
      id: 2,
      type: 'call',
      title: 'AI call completed',
      description: 'John Smith - 3:24 duration',
      timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000),
      icon: FiPhone,
      color: 'green'
    },
    {
      id: 3,
      type: 'contact',
      title: 'New contact added',
      description: 'Sarah Johnson from Acme Corp',
      timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000),
      icon: FiUser,
      color: 'purple'
    },
    {
      id: 4,
      type: 'campaign',
      title: 'Campaign completed',
      description: 'Product Launch - 89% open rate',
      timestamp: new Date(Date.now() - 8 * 60 * 60 * 1000),
      icon: FiActivity,
      color: 'orange'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
    orange: 'bg-orange-100 text-orange-600'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Recent Activity</h3>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
          View All
        </button>
      </div>

      <div className="space-y-4">
        {activities.map((activity, index) => (
          <motion.div
            key={activity.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <div className={`w-8 h-8 rounded-full ${colorClasses[activity.color]} flex items-center justify-center flex-shrink-0`}>
              <SafeIcon icon={activity.icon} className="text-sm" />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900">{activity.title}</p>
              <p className="text-sm text-gray-500">{activity.description}</p>
              <p className="text-xs text-gray-400 mt-1">
                {format(activity.timestamp, 'MMM d, yyyy h:mm a')}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;